export default "__VITE_ASSET__C6Wd_7GE__"